module.exports = __webpack_public_path__ + "files/e2107061b7f027082e3483e1bf048b51.png";